import React from 'react';
import FrontRecapitulatif from './recapitulatif';
import waiter from '../img/wait.svg'
import FrontFooter from './footer'
import FrontProgress from './progress';

export default class FrontSubscribing extends React.Component {
    
    constructor(props) {
        super(props);
        this.timer = false
    }

    componentDidMount() {
        this.timer = setInterval(
            this.props.checkStatus,
            5000
        )
    }

    componentWillUnmount() {
        if ( this.timer ) {
            clearInterval( this.timer )
            this.timer = false
        }
    }

    render() {
        const params = this.props.devis.params
        const container = {
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            setPage: this.props.setPage
        }
        return <>
        <FrontProgress comparateursCompleted={true} setPage={this.props.setPage} page={this.props.page} topRef={this.props.topRef}/>
{/*        <div className="titlebox" ref={this.props.topRef}>
            Votre souscription est en cours d'enregistrement
            <div className="hr"><img src={journal} className="journal"/></div>
    </div> */}
        <div className="container">
            <div className="contentbox">
                <div className="contentvbox">
                    <h1 className="top_title">Merci pour votre paiement</h1>

                    <p>
                    La souscription peut prendre jusqu'à une minute. Merci de ne pas fermer cette fenêtre.
                    </p>
                    <p>
                        <img src={waiter} className="little_waiter"/>
                    </p>
                </div>
            </div>
            <div className="contentbox_middle"/>

            <div className="contentbox contentbox_right">
                <FrontRecapitulatif api={this.props.api} devis={this.props.devis} container={container}/>

                <h1 className="subscribe">Contactez nous par téléphone</h1>
                <a href="tel:0974772861" className="tel">09 74 77 28 61</a>
            </div>

            </div>
            <FrontFooter/>
        </>
    }
}